import React from 'react'
import LoaderGif from "../assets/gif/loader.gif";

function Loader() {
  return (
    <div className="loader-overlay">
          <img src={LoaderGif} alt="Loading..." className="loader-gif" />
        </div>
  )
}

export default Loader